import catalogModule from '../catalogModule';
import menuConstants from '../constants/menuConstants';

function searchOptionsController($log, $scope, catalogConstants, constantsService) {
  'ngInject';

  $scope.canShowFilters = () => {
    return (
      (!$scope.library.isSplashPage || $scope.categoryOptimizationEnabled) &&
      $scope.isSearchableCategory($scope.currentQuery.category)
    );
  };

  $scope.canShowGenreFilters = () => {
    if (!$scope.genreAllowed) {
      return false;
    }

    const categoryId = $scope.currentQuery?.category?.categoryId;
    if (categoryId === undefined) {
      return true;
    }

    if (categoryId === menuConstants.categoryTypes.CommunityCreations) {
      return false;
    }

    if (categoryId === menuConstants.categoryTypes.Clothing) {
      // default is true, so if the data is missing we should still return true
      // hence, return false iff this field is exactly false
      return $scope.areGenreFiltersShownForClothingCategories !== false;
    }

    return true;
  };

  $scope.canToggleSubmenu = category => {
    const { subcategories } = category;
    return subcategories && subcategories.length > 0;
  };

  $scope.isUGCOnly = () => {
    const result =
      $scope.currentQuery?.category?.categoryId === menuConstants.categoryTypes.CommunityCreations;
    return result;
  };
}

catalogModule.controller('searchOptionsController', searchOptionsController);

export default searchOptionsController;
